(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ark-filter-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ark-catalogue')) {
    /**
     * Collection filtering and sorting in place. The form and links are real URLs; this
     * only fetches the same URL's section HTML and swaps the regions that changed.
     */
    class ArkCatalogue extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('[data-ark-filters]');

        this.addEventListener(
          'click',
          (event) => {
            const target = /** @type {HTMLElement} */ (event.target);
            if (target.closest('[data-ark-open-filters]')) {
              this.trigger = target.closest('button');
              this.dialog?.showModal();
              return;
            }
            if (target.closest('[data-ark-close]') || target === this.dialog) {
              this.dialog?.close();
              return;
            }
            const link = target.closest('a[data-ark-link]');
            if (link instanceof HTMLAnchorElement && !event.metaKey && !event.ctrlKey) {
              event.preventDefault();
              this.update(link.href);
            }
          },
          { signal }
        );

        this.dialog?.addEventListener('close', () => this.trigger?.focus(), { signal });

        // Any change in the sheet updates the grid behind it; the sheet stays open.
        this.form?.addEventListener('change', () => this.update(this.urlFromForm(), { keepSheet: true }), { signal });
        this.form?.addEventListener(
          'submit',
          (event) => {
            event.preventDefault();
            this.dialog?.close();
            this.update(this.urlFromForm());
          },
          { signal }
        );

        // The toolbar sort (desktop) mirrors the sheet's sort.
        this.addEventListener(
          'change',
          (event) => {
            const select = /** @type {HTMLElement} */ (event.target);
            if (!(select instanceof HTMLSelectElement) || !select.matches('[data-ark-sort]')) return;
            const radio = this.form?.querySelector(`input[name="sort_by"][value="${CSS.escape(select.value)}"]`);
            if (radio instanceof HTMLInputElement) radio.checked = true;
            this.update(this.urlFromForm());
          },
          { signal }
        );

        window.addEventListener('popstate', () => this.update(location.href, { push: false }), { signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.fetchController?.abort();
      }

      urlFromForm() {
        const data = new FormData(/** @type {HTMLFormElement} */ (this.form));
        const params = new URLSearchParams();
        for (const [key, value] of data) {
          if (typeof value === 'string' && value !== '') params.append(key, value);
        }
        const query = params.toString();
        return `${this.form?.getAttribute('action')}${query ? `?${query}` : ''}`;
      }

      /**
       * @param {string} href
       * @param { { push?: boolean, keepSheet?: boolean } } [options]
       */
      async update(href, { push = true, keepSheet = false } = {}) {
        const url = new URL(href, location.origin);
        const fetchUrl = new URL(url);
        fetchUrl.searchParams.set('section_id', this.dataset.sectionId || '');

        this.fetchController?.abort();
        this.fetchController = new AbortController();
        this.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(fetchUrl, { signal: this.fetchController.signal });
          if (!response.ok) throw new Error(String(response.status));
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const regions = keepSheet ? ['toolbar', 'active', 'results'] : ['toolbar', 'active', 'results', 'filters'];
          for (const name of regions) {
            const next = html.querySelector(`[data-ark-region="${name}"]`);
            const current = this.querySelector(`[data-ark-region="${name}"]`);
            if (next && current) current.replaceWith(next);
          }
          const nextApply = html.querySelector('[data-ark-apply]');
          const apply = this.querySelector('[data-ark-apply]');
          if (nextApply && apply) apply.textContent = nextApply.textContent;
          const shortcuts = html.querySelector('.ark-catalogue__shortcuts');
          this.querySelector('.ark-catalogue__shortcuts')?.replaceWith(shortcuts ?? document.createTextNode(''));
          if (push) history.pushState({}, '', url.pathname + url.search);
        } catch (error) {
          if (/** @type {Error} */ (error).name !== 'AbortError') location.assign(url);
        } finally {
          this.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('ark-catalogue', ArkCatalogue);
  }
  } catch(e) { console.error(e); }
})();

})();
